import classNames from 'classnames';
import React, { ReactElement } from 'react';
import './badge.scss';

const Badge: React.FC<{
    className?: string;
    color?: 'default' | 'green' | 'purple' | 'yellow' | 'light-blue' | 'light-green' | 'dark-blue' | 'light-orange' | 'grey' | 'red';
    weight?: '500' | '600' | '700';
    borderRadius?: 'full' | 'opposite';
    filled?: boolean;
}> = ({
    className,
    color = 'default',
    children,
    weight = '500',
    borderRadius = 'full',
    filled = true
}): ReactElement => (
    <span
        className={classNames({
            [`badge--${color}`]: true,
            [`badge--${color}--filled`]: filled,
            [className || '']: className,
            [`badge--${borderRadius}`]: true,
            [`badge--fw-${weight}`]: true,
            badge: true
        })}
    >
        {children}
    </span>
);

export default Badge;
